/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_No_Tags_FoundInputs */



/**
* | output |
* | --- |
* | "No tags found" |
*
* @param {Tags_No_Tags_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_no_tags_found = /** @type {((inputs?: Tags_No_Tags_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_No_Tags_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun tag trouve")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Tags gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun tag trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Теги не найдены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron etiquetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到标签")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई टैग नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma etiqueta encontrada")
	return /** @type {LocalizedString} */ ("No tags found")
});